import { render } from "./SkillLevels.vue?vue&type=template&id=4c4c288f&scoped=true"
import script from "./SkillLevels.vue?vue&type=script&lang=ts"
export * from "./SkillLevels.vue?vue&type=script&lang=ts"

import "./SkillLevels.vue?vue&type=style&index=0&id=4c4c288f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c4c288f"

export default script